export const LOAD_CROPS = 'load_agronomy_agreement_crops';
export const CROPS_LOADED = 'set_loaded_agronomy_agreement_crops';
export const RESET_CROPS = 'reset_agronomy_agreement_crops';
export const SYNC_FAILED = 'agronomy_agreement_crops_sync_error';
